/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I enter negative numbers?`)
};

const es_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo introducir números negativos?`)
};

const de_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich negative Zahlen eingeben?`)
};

const nl_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik negatieve getallen invoeren?`)
};

const fr_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je entrer des nombres négatifs ?`)
};

const it_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso inserire numeri negativi?`)
};

const pt_br2_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso inserir números negativos?`)
};

const pt_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso introduzir números negativos?`)
};

const ja_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`負の数を入力できますか？`)
};

const zh_nb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以输入负数吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq3_q", locale)
	if (locale === "en") return en_nb_faq3_q(inputs)
	if (locale === "es") return es_nb_faq3_q(inputs)
	if (locale === "de") return de_nb_faq3_q(inputs)
	if (locale === "nl") return nl_nb_faq3_q(inputs)
	if (locale === "fr") return fr_nb_faq3_q(inputs)
	if (locale === "it") return it_nb_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq3_q(inputs)
	if (locale === "pt") return pt_nb_faq3_q(inputs)
	if (locale === "ja") return ja_nb_faq3_q(inputs)
	return zh_nb_faq3_q(inputs)
};